export const REMOVE_ACTION = {
    ERASE: 'erase',
    RESTORE: 'restore',
    DRAG: 'drag',
    NONE: '',
}

// brush shape
export const buildCursorDataUrl = (mode, size) => {
    const radius = size / 2
    const strokeInner = '#414245'
    const strokeOuter = '#FFFFFF'
    const iconColor = '#414245'
    const iconOutline = '#FFFFFF'

    const iconScaleFactor = 0.4
    const iconStrokeWidth = 1.5
    const iconContainerSize = size * iconScaleFactor

    let iconPath
    let iconX, iconY

    if (mode === REMOVE_ACTION.ERASE) {
        const iconWidth = iconContainerSize
        const iconHeight = iconContainerSize * 0.1
        iconX = (size - iconWidth) / 2
        iconY = (size - iconHeight) / 2

        iconPath = `<rect x="0" y="0" width="${iconWidth}" height="${iconHeight}" />`
    } else {
        const iconSize = iconContainerSize
        iconX = (size - iconSize) / 2
        iconY = (size - iconSize) / 2

        const barThickness = iconSize * 0.1
        const barOffset = (iconSize - barThickness) / 2

        iconPath = `
            <rect x="${barOffset}" y="0" width="${barThickness}" height="${iconSize}" />
            <rect x="0" y="${barOffset}" width="${iconSize}" height="${barThickness}" />
        `
    }

    const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
  <g>
    <circle cx="${radius}" cy="${radius}" r="${radius - 1}" stroke="${strokeOuter}" stroke-width="1.5" fill="none"/>
    <circle cx="${radius}" cy="${radius}" r="${radius - 2.5}" stroke="${strokeInner}" stroke-width="1" fill="none"/>

    <g transform="translate(${iconX}, ${iconY})">
      <g stroke="${iconOutline}" stroke-width="${iconStrokeWidth * 2}" fill="none">
         ${iconPath}
      </g>
      <g fill="${iconColor}">
         ${iconPath}
      </g>
    </g>
  </g>
</svg>
`.trim()

    const encoded = encodeURIComponent(svg).replace(/'/g, '%27').replace(/"/g, '%22')
    return `url("data:image/svg+xml,${encoded}") ${radius} ${radius}, auto`
}

